import { h } from "@stencil/core";
import { createContext } from '../../utils/createContext';
const { Provider, Consumer } = createContext({ defaultValue: 'foo' });
export class MyComponentChild {
    constructor() {
        this.clear = false;
        window.setTimeout(() => {
            this.childProvider = { defaultValue: 'first-level-updated-4sec' };
        }, 4000);
        window.setTimeout(() => {
            this.clear = true;
        }, 6000);
    }
    render() {
        return (h(Consumer, null, ({ defaultValue }) => [
            h("div", null,
                "2. ",
                defaultValue,
                " (child)"),
            h(Provider, { value: this.clear
                    ? { defaultValue }
                    : this.childProvider || { defaultValue } },
                h("my-component-grandchild", null),
                this.clear ? null : h(Consumer, null, () => { })),
        ]));
    }
    static get is() { return "my-component-child"; }
    static get states() { return {
        "childProvider": {},
        "clear": {}
    }; }
}
